import numeral from 'numeral'
import {
  string,
  number,
  bool,
  oneOfType,
  func,
  oneOf,
  object,
} from 'prop-types'
import { Fragment } from 'react'
import {
  Currency,
  Tooltip,
  Conditional,
  kuiperClassNames,
  renderIcon,
  kuiperClassNamesWithTracking,
} from '@opallabs/kuiper'
import './styles.scss'

const modalDescription =
  ' Story budgets can be allocated to the moments and content within.'

const getRemainingBudget = (totalBudget, value) => {
  const formattedValue = numeral(value).value()
  return numeral(totalBudget - formattedValue).format('$0,0')
}

const BudgetInput = ({
  context,
  disabled = false,
  iconOptions,
  name = '',
  onBlur,
  onChange,
  onFocus,
  parentContext,
  theme = 'dark',
  totalBudget,
  trackingClassName,
  value = '',
}) => {
  const isModal = context === 'story'

  const title = (
    <Conditional condition={!isModal}>
      <Fragment>
        Budget Allocation
        {renderIcon('budget-m', { ariaMode: 'hidden' })}
      </Fragment>
    </Conditional>
  )

  return (
    <div
      className={kuiperClassNamesWithTracking('budget-input', theme, {
        tracking: trackingClassName,
      })}
    >
      <Conditional condition={isModal}>
        <div className={kuiperClassNames('currency-label')}>
          <div className={kuiperClassNames('modal-header')}>
            <label
              className={kuiperClassNames('budget-label')}
              htmlFor="budget-field"
            >
              Budget
            </label>
            <p>{modalDescription}</p>
          </div>
        </div>
      </Conditional>
      <Currency
        value={value}
        htmlId="budget-field"
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={(currentValue) => onChange(currentValue)}
        shouldValidate={false}
        theme={theme}
        title={title}
        disabled={disabled}
      />
      <Conditional condition={totalBudget}>
        <div className={kuiperClassNames('budget-details')}>
          <p className={kuiperClassNames('budget-remaining')}>
            {getRemainingBudget(totalBudget, value)}
          </p>
          {/* I think it's ok to hide this icon (and lose access to the story
              name that's provided by the tooltip) because I think the budget
              comes from the primary story. If the budget can actually come
              from *any* associated story the relevant story name should be
              presented to the screen reader somehow.
              - jordan@
            */}
          <Tooltip
            className="budget-tooltip"
            position="top"
            content={name}
            trigger={
              renderIcon(parentContext, {
                ...iconOptions,
                ariaMode: 'hidden',
              }) || ''
            }
          />
        </div>
      </Conditional>
    </div>
  )
}

BudgetInput.propTypes = {
  context: oneOf(['post', 'moment', 'story']),
  disabled: bool,
  iconOptions: object,
  name: string,
  onBlur: func,
  onChange: func,
  onFocus: func,
  parentContext: string,
  theme: oneOf(['light', 'dark']),
  totalBudget: number,
  trackingClassName: string,
  value: oneOfType([string, number]),
}

export default BudgetInput
